export default `Region,Population
Brasil,210147125
Região Norte,18430980
Rondônia,1777225
Acre,881935
Amazonas,4144597
Roraima,605761
Pará,8602865
Amapá,845731
Tocantins,1572866
Região Nordeste,57071654
Maranhão,7075181
Piauí,3273227
Ceará,9132078
Rio Grande do Norte,3506853
Paraíba,4018127
Pernambuco,9557071
Alagoas,3337357
Sergipe,2298696
Bahia,14873064
Região Sudeste,88371433
Minas Gerais,21168791
Espírito Santo,4018650
Rio de Janeiro,17264943
São Paulo,45919049
Região Sul,29975984
Paraná,11433957
Santa Catarina,7164788
Rio Grande do Sul,11377239
Região Centro-Oeste,16297074
Mato Grosso do Sul,2778986
Mato Grosso,3484466
Goiás,7018354
Distrito Federal,3015268`